import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useSubscription } from '@/contexts/SubscriptionContext';

import AuthGateway from '@/components/AuthGateway';

const ProtectedRoute = ({ children, requireAdmin = false, requirePlan = null }) => {
    const { user, loading: authLoading } = useAuth();
    const { subscription, loading: subLoading } = useSubscription();
    const location = useLocation();

    // Wait for both auth and subscription to load
    if (authLoading || subLoading) {
        return <div className="min-h-screen flex items-center justify-center">Cargando...</div>;
    }

    // Check authentication first
    if (!user) {
        // Show Auth Gateway directly instead of redirect
        return <AuthGateway />;
    }

    // Check admin requirement
    if (requireAdmin && user.role !== 'admin') {
        // If user is logged in but not admin, redirect to dashboard
        return <Navigate to="/dashboard" replace />;
    }

    // Check plan requirement (P0 CRITICAL)
    if (requirePlan && subscription) {
        const allowedPlans = {
            'pro': ['pro', 'superior', 'premium', 'master'],
            'master': ['superior', 'premium', 'master']
        };

        const userPlan = (subscription.plan || '').toLowerCase();
        const requiredPlans = allowedPlans[requirePlan] || [];

        if (!requiredPlans.includes(userPlan)) {
            // User doesn't have required plan, redirect to subscription page
            return <Navigate to="/subscription" state={{
                from: location,
                requiredPlan: requirePlan,
                message: `Esta página requiere el Plan ${requirePlan.toUpperCase()}`
            }} replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
